module.exports = __webpack_public_path__ + "static/media/n2_jaune.a31013a7.svg";